export default "__VITE_ASSET__DQTpq72M__"